import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import DatePicker from 'components/DatePicker'
import {getReport} from 'redux/modules/reports/selectors'
import {setReportRange, downloadCSV} from 'redux/modules/reports/actions'
import moment from 'moment'
class ReportViewMenu extends React.Component {
  static propTypes = {
    loading: PropTypes.bool,
    report: PropTypes.object,
    today: PropTypes.instanceOf(Date),
    setReportRange: PropTypes.func,
    downloadCSV: PropTypes.func,
    crossSiteMode: PropTypes.bool
  }

  static contextTypes = {
    currency: PropTypes.string,
    timezone: PropTypes.string
  }

  render() {
    const {report, today, loading} = this.props
    const {startDate, endDate, dynamicDateType} = report || {}

    return (
      <div className='report-view-menu'>
        <button className='report-view-menu_download is-normal' disabled={loading} onClick={this.onDownloadPDFClick}>Download PDF</button>
        <button className='report-view-menu_download is-normal' onClick={this.onDownloadCSVClick}>Download CSV</button>
        {startDate && endDate &&
          <DatePicker
            className='report-view-menu_datepicker'
            onSelect={this.onDateSelect}
            disabled={loading}
            startDate={moment(startDate).toDate()}
            endDate={moment(endDate).toDate()}
            dynamicDateType={dynamicDateType}
            today={today}
            minDate={null}
          />
        }
      </div>
    )
  }

  onDateSelect = (startDate, endDate, dynamicDateType) => {
    const {report: {id}, setReportRange, crossSiteMode} = this.props
    const {currency, timezone} = this.context
    if (!dynamicDateType) {
      dynamicDateType = null
    }

    setReportRange(id, startDate, endDate, dynamicDateType, crossSiteMode, currency, timezone)
  }

  onDownloadCSVClick = () => {
    const {report, downloadCSV, crossSiteMode} = this.props
    const {currency, timezone} = this.context
    downloadCSV(report, crossSiteMode, currency, timezone)
  }
  onDownloadPDFClick = () => {
    const {report} = this.props
    const tempTitle = document.title
    const timestamp = new Date().getTime()
    document.title = `${report.name}.${timestamp}.pdf`
    window.print()
    document.title = tempTitle
  }
}

const mapStateToProps = (state, props) => {
  const {reportId} = props.params
  const crossSiteMode = props.route.crossSiteMode
  return {
    report: getReport(state, reportId),
    today: state.today,
    loading: (!state.reports) ? true : (!state.reports[reportId]) ? true : (!state.reports[reportId].data),
    crossSiteMode
  }
}

export default connect(mapStateToProps, {
  setReportRange,
  downloadCSV
})(ReportViewMenu)



// WEBPACK FOOTER //
// ./client/views/ReportView/Menu.js